import {
  contactChannelLabels,
  contactNumberUrl,
  formatPhone,
  type ContactNumber,
} from '@hue/contracts';
import { Phone, Send } from 'lucide-react';

function WhatsAppIcon() {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.7"
      className="size-4 shrink-0"
      aria-hidden="true"
    >
      <path d="M20.5 11.8a8.7 8.7 0 0 1-12.9 7.6L3 21l1.5-4.7a8.7 8.7 0 1 1 16-4.5Z" />
      <path d="m8.2 7.3 1.3 2.6-1 1a7.5 7.5 0 0 0 4.5 4.1l.9-1.3 2.7 1.2c-.2 1.6-1.4 2.2-2.9 1.9-3.7-.8-7.1-4.2-7.2-7.2 0-1.3.5-2.1 1.7-2.3Z" />
    </svg>
  );
}
export function ContactNumberLinks({ numbers = [] }: { numbers?: ContactNumber[] | undefined }) {
  return (
    <div className="flex min-w-0 flex-wrap gap-x-5 gap-y-3">
      {numbers
        .filter((item) => item.isPublic)
        .flatMap((item, index) =>
          item.channels.map((channel) => (
            <a
              key={`${index}-${channel}`}
              href={contactNumberUrl(item.number, channel)}
              {...(channel === 'CALL' ? {} : { target: '_blank', rel: 'noopener noreferrer' })}
              className="inline-flex min-w-0 items-center gap-2 text-sm font-semibold underline underline-offset-4"
            >
              {channel === 'WHATSAPP' ? (
                <WhatsAppIcon />
              ) : channel === 'TELEGRAM' ? (
                <Send className="size-4 shrink-0" aria-hidden="true" />
              ) : (
                <Phone className="size-4 shrink-0" aria-hidden="true" />
              )}
              <span>
                {item.label} · {contactChannelLabels[channel]} ·{' '}
                {formatPhone(item.number) ?? item.number}
              </span>
            </a>
          )),
        )}
    </div>
  );
}
